import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { catchError } from 'rxjs/operators';
import { utility } from '../common/utility';


@Injectable({
    providedIn: 'root'
})

export class MemberService {

    baseUrl: string;
    constructor(private http: HttpClient) {
    }

    public GetMemberById(id): Observable<any> {
        this.baseUrl = environment.apiBase.concat("Member/GetMemberById?Id=" + id);
        return this.http.get<any[]>(this.baseUrl).pipe(catchError(utility.handleError<any[]>('GetMemberById', [])));
    
    }
    public GetChildOfficesByParentOfficeId(ParentOfficeId: any): Observable<any> {

        this.baseUrl = environment.apiBase.concat("Member/GetChildOfficesByParentOfficeId?ParentOfficeId=" + ParentOfficeId);

        return this.http.get<any[]>(this.baseUrl).pipe(catchError(utility.handleError<any[]>('GetChildOfficesByParentOfficeId', [])));
    }
    public GetAllOfficeLocations(memberid: any): Observable<any> {

        this.baseUrl = environment.apiBase.concat("Member/GetAllOfficeLocations?memberid=" + memberid);

        return this.http.get<any[]>(this.baseUrl).pipe(catchError(utility.handleError<any[]>('GetAllOfficeLocations', [])));
    }
    public GetAllHQAndCorporateOffices(): Observable<any> {

        this.baseUrl = environment.apiBase.concat("Member/GetAllHQAndCorporateOffices");

        return this.http.get<any[]>(this.baseUrl).pipe(catchError(utility.handleError<any[]>('GetChildOfficesByParentOfficeId', [])));
    }
    public AddMember(member: any): Observable<any> {
        this.baseUrl = environment.apiBase.concat("Member");
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');      
        return this.http.post(this.baseUrl, member, { headers: headers }).
            pipe(catchError(err => {
                return utility.handleErrorNew(err);
            }),);
    }

    public UpdateMember(member: any): Observable<any> {
        this.baseUrl = environment.apiBase.concat("Member");
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');

        return this.http.put(this.baseUrl, member, { headers: headers })
             .pipe(catchError(err => {
                 return utility.handleErrorNew(err);
             }));
    }
    public SetApprovingManager(memberid: any, userid : any): any {
        this.baseUrl = environment.apiBase.concat("Member/SetApprovingManager?MemberId=" + memberid + "&userid=" + userid);
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        return this.http.post(this.baseUrl,  { headers: headers }).
            pipe(catchError(utility.handleError<any>('SetApprovingManager', [])));
    }
    public GetMemberByTerritoryCoordinates(latitude: any, longitude: any): Observable<any> {
        this.baseUrl = environment.apiBase.concat("Member/GetMemberByTerritoryCoordinates?latitude=" + latitude + "&longitude=" + longitude);
        return this.http.get<any[]>(this.baseUrl).pipe(catchError(utility.handleError<any[]>('GetMemberByTerritoryCoordinates', [])));
    
    }
    public GetMemberByTerritoryAddress(Address: any): Observable<any> {
        this.baseUrl = environment.apiBase.concat("Member/GetMemberByTerritoryAddress?Address=" + Address);
        return this.http.get<any[]>(this.baseUrl).pipe(catchError(utility.handleError<any[]>('GetMemberByTerritoryAddress', [])));
    
    }
    public GetMemberTerritories(memberid: any): Observable<any> {

        this.baseUrl = environment.apiBase.concat("Member/GetAllMemberTerritories?memberid=" + memberid);

        return this.http.get<any[]>(this.baseUrl).pipe(catchError(utility.handleError<any[]>('GetAllMemberTerritories', [])));
    }
    public DeleteMemberTerritory(memberid:any, memberterritoryid: any): any {
        this.baseUrl = environment.apiBase.concat("Member/DeleteMemberTerritory?MemberId=" + memberid + "&MemberTerritoryId=" + memberterritoryid);
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        return this.http.post(this.baseUrl,  { headers: headers }).
            pipe(catchError(utility.handleError<any>('DeleteMemberTerritory', [])));
    }
    public InsertMemberTerritory(memberid: any, startAddress : any, CountryCode: any, granularityLevel: any): any {
        this.baseUrl = environment.apiBase.concat("Member/InsertMemberTerritory?MemberId=" + memberid + "&startAddress=" + startAddress + "&countryRegion=" + CountryCode 
                + "&granularityLevel=" + granularityLevel);
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        return this.http.post(this.baseUrl,  { headers: headers }).
            pipe(catchError(utility.handleError<any>('InsertMemberTerritory', [])));
    }
    public SearchMembersLazy(first =0, numberOfRow= 0, name, includeinactive = false): Observable<any> {
        this.baseUrl = environment.apiBase.concat("Member/SearchMembersLazy?First="+first +"&NumberOfRow="+numberOfRow + "&SearchString=" + name + "&IncludeInactive=" + includeinactive);
        return this.http.get<any[]>(this.baseUrl).pipe(catchError(utility.handleError<any[]>('SearchUsers', [])));
    }
    public SearchMembersAdvanceLazy(parms): Observable<any> {
        this.baseUrl = environment.apiBase.concat("Member/SearchMembersAdvanceLazy");
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        return this.http.post(this.baseUrl, parms, { headers: headers })
            .pipe(catchError(utility.handleError<any[]>('SearchMembersAdvanceLazy', [])));
    }
    public SearchMembers(name, includeinactive = false): Observable<any> {
        this.baseUrl = environment.apiBase.concat("Member/SearchMembers?SearchString=" + name + "&IncludeInactive=" + includeinactive);
        return this.http.get<any[]>(this.baseUrl).pipe(catchError(utility.handleError<any[]>('SearchUsers', [])));
    }
    public UpdateMemberFavorite(member: any): any {
        this.baseUrl = environment.apiBase.concat("Member/UpdateMemberFavorite");
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        return this.http.post(this.baseUrl, member, { headers: headers }).
            pipe(catchError(utility.handleError<any>('UpdateMemberFavorite', [])));
    }
}
